import { render, staticRenderFns } from "./packPage.vue?vue&type=template&id=d212eaf6&scoped=true"
import script from "./packPage.vue?vue&type=script&lang=js"
export * from "./packPage.vue?vue&type=script&lang=js"
import style0 from "./packPage.vue?vue&type=style&index=0&id=d212eaf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d212eaf6",
  null
  
)

export default component.exports